import { type Theme } from '@mui/material'
import { styled } from '@mui/material'
import TextField from '@mui/material/TextField'

interface SearchBarProps {
  theme?: Theme
  expanded: boolean
  fillContainer?: boolean
}

export const SearchBar = styled(TextField)<SearchBarProps>(({ theme, expanded, fillContainer }) => ({
  width: (expanded ? (fillContainer ? '100%' : theme.spacing(80)) : theme.spacing(10)),
  maxWidth: (fillContainer ? '100%' : theme.spacing(80)),
  transition: '.4s',
  cursor: 'pointer',
  '& .MuiOutlinedInput-root': {
    borderRadius: theme.spacing(2),
    height: theme.spacing(10),
    paddingLeft: theme.spacing(3)
  },
  '& .MuiInputBase-input ': {
    paddingLeft: 0
  }
}))
